import script from "./BrowseProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowseProducts.vue?vue&type=script&setup=true&lang=js"

import "./BrowseProducts.vue?vue&type=style&index=0&id=79ce8cce&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ce8cce"]])

export default __exports__